window.MEDKA_PERSO = window.MEDKA_PERSO || {};
window.MEDKA_PERSO.hotspots = window.MEDKA_PERSO.hotspots || {};

// WELT – candy blue (specjalny układ)
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-candy-blue"] = {
  text: {
    left:  { x: 0.58, y: 0.23, w: 0.28, h: 0.12 },
    right: { x: 0.26, y: 0.23, w: 0.28, h: 0.12 }
  },
  logo: {
    left:  { x: 0.60, y: 0.28, w: 0.22, h: 0.10 },
    right: { x: 0.28, y: 0.28, w: 0.22, h: 0.10 }
  }
};

// WELT – reszta (ten sam układ)
[
  "bluza-medyczna-damska-welt-czekoladowa",
  "bluza-medyczna-damska-welt-limonka",
  "bluza-medyczna-damska-welt-szalwia",
  "bluza-medyczna-damska-welt-misty-rose",
  "bluza-medyczna-damska-welt-sky-blue-1",
  "bluza-medyczna-damska-welt-frozen",
  "bluza-medyczna-damska-welt-amethyst",
  "bluza-medyczna-damska-welt-roseberry",
  "bluza-medyczna-damska-welt-deep-rose",
  "bluza-medyczna-damska-welt-cherry-smoke",
  "bluza-medyczna-damska-welt-red-fox",
  "bluza-medyczna-damska-welt-emerald-green",
  "bluza-medyczna-damska-welt-blekitna-indygo",
  "bluza-medyczna-damska-welt-navyblue",
  "bluza-medyczna-damska-welt-czarna"
].forEach(handle => {
  window.MEDKA_PERSO.hotspots[handle] = {
    text: {
      left:  { x: 0.20, y: 0.08, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.08, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
    }
  };
});

// MOXI – wszystkie kolory (ten sam układ)
[
  "bluza-medyczna-damska-moxi-biala",
  "bluza-medyczna-damska-moxi-vanilla",
  "bluza-medyczna-damska-moxi-limonka",
  "bluza-medyczna-damska-moxi-misty-rose",
  "bluza-medyczna-damska-moxi-sky-blue",
  "bluza-medyczna-damska-moxi-szalwia",
  "bluza-medyczna-damska-moxi-oliwkowa",
  "bluza-medyczna-damska-moxi-amethyst",
  "bluza-medyczna-damska-moxi-frozen",
  "bluza-medyczna-damska-moxi-candy-blue",
  "bluza-medyczna-damska-moxi-roseberry",
  "bluza-medyczna-damska-moxi-deep-rose",
  "bluza-medyczna-damska-moxi-cherry-smoke",
  "bluza-medyczna-damska-moxi-red-fox",
  "bluza-medyczna-damska-moxi-czekoladowa",
  "bluza-medyczna-damska-moxi-espresso",
  "bluza-medyczna-damska-moxi-emerald-green",
  "bluza-medyczna-damska-moxi-indygo",
  "bluza-medyczna-damska-moxi-czarna"
].forEach(handle => {
  window.MEDKA_PERSO.hotspots[handle] = {
    text: {
      left:  { x: 0.20, y: 0.09, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.09, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
    }
  };
});

// NAYA – baza (większość kolorów)
[
  "tunika-medyczna-naya-vanilla",
  "tunika-medyczna-naya-misty-rose",
  "tunika-medyczna-naya-candy-blue",
  "tunika-medyczna-naya-cherry-smoke",
  "tunika-medyczna-naya-emerald-green",
  "tunika-medyczna-naya-czekoladowa",
  "tunika-medyczna-naya-czarny"
].forEach(handle => {
  window.MEDKA_PERSO.hotspots[handle] = {
    text: {
      left:  { x: 0.18, y: 0.09, w: 0.26, h: 0.30 },
      right: { x: 0.52, y: 0.09, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.18, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.52, y: 0.03, w: 0.26, h: 0.30 }
    }
  };
});

// NAYA – wyjątki wg Twoich wartości
window.MEDKA_PERSO.hotspots["tunika-medyczna-naya-sky-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.09, w: 0.26, h: 0.30 },
    right: { x: 0.55, y: 0.09, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
    right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
  }
};

window.MEDKA_PERSO.hotspots["tunika-medyczna-naya-biala"] = {
  text: {
    left:  { x: 0.15, y: 0.09, w: 0.26, h: 0.30 },
    right: { x: 0.55, y: 0.09, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.15, y: 0.03, w: 0.26, h: 0.30 },
    right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
  }
};

window.MEDKA_PERSO.hotspots["tunika-medyczna-naya-espresso"] = {
  text: {
    left:  { x: 0.22, y: 0.09, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.09, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.03, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.03, w: 0.26, h: 0.30 }
  }
};

window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-candy-blue"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-bezowy"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-indygo"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-navy-blue"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-oliwkowy"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-stalowy"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-axis-czarny"] = {
  text: {
    left:  { x: 0.22, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.22, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.52, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["fartuch-medyczny-damski-fabella-z-krotkim-rekawem"] = {
  text: {
    left:  { x: 0.03, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.72, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.03, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.72, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["fartuch-medyczny-damski-fabella-z-dlugim-rekawem"] = {
  text: {
    left:  { x: 0.03, y: 0.12, w: 0.26, h: 0.30 },
    right: { x: 0.72, y: 0.12, w: 0.26, h: 0.30 }
  },
  logo: {
    left:  { x: 0.03, y: 0.06, w: 0.26, h: 0.30 },
    right: { x: 0.72, y: 0.06, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-moxi-butter-yellow"] = {
  text: {
  left:  { x: 0.20, y: 0.08, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.08, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-moxi-flamingo"] = {
  text: {
  left:  { x: 0.20, y: 0.08, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.08, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-moxi-orange-juice"] = {
  text: {
  left:  { x: 0.20, y: 0.08, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.08, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-moxi-vein-blue"] = {
  text: {
  left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-moxi-tropical-blue"] = {
  text: {
  left:  { x: 0.20, y: 0.08, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.08, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-tropical-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-butter-yellow"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-orange-juice"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-flamingo"] = {
  text: {
    left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-vein-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-lagoon-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-emerald-green"] = {
  text: {
    left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-espresso"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.28 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.28 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-candy-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.26 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.26 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-cherry-smoke"] = {
  text: {
    left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.26 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.26 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-fortis-navy-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.04, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.04, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.26 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.26 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-vanilla"] = {
  text: {
    left:  { x: 0.20, y: 0.04, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.04, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.00, w: 0.26, h: 0.28 },
      right: { x: 0.55, y: 0.00, w: 0.26, h: 0.28 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-welt-espresso"] = {
  text: {
    left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-navy-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-roseberry"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-sky-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-czarna"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-cherry-smoke"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-brownie-cake"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.01, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.01, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-navy-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-emerald-green"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-espresso"] = {
  text: {
    left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-stalowa"] = {
  text: {
    left:  { x: 0.20, y: 0.07, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.07, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.04, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.04, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-cherry-smoke"] = {
  text: {
    left:  { x: 0.20, y: 0.05, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.05, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-meska-polo-czarna"] = {
  text: {
    left:  { x: 0.20, y: 0.07, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.07, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.04, w: 0.26, h: 0.25 },
      right: { x: 0.55, y: 0.04, w: 0.26, h: 0.25 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-biala"] = {
  text: {
    left:  { x: 0.20, y: 0.06, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.06, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.02, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.02, w: 0.26, h: 0.30 }
  }
};
window.MEDKA_PERSO.hotspots["bluza-medyczna-damska-mila-vein-blue"] = {
  text: {
    left:  { x: 0.20, y: 0.07, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.07, w: 0.26, h: 0.30 }
    },
    logo: {
      left:  { x: 0.20, y: 0.03, w: 0.26, h: 0.30 },
      right: { x: 0.55, y: 0.03, w: 0.26, h: 0.30 }
  }
};